import React from 'react';
import { observer } from 'mobx-react';

import { InjectedStyledComponent } from '../../../../../shared/index.js';
import { ITableEvents } from '../../models/index.js';
import HeadCell from '../HeadCell/HeadCell.js';
import { TableComponentBase } from '../TableComponentBase.js';

import { IHeadRowConfiguration, IHeadRowProps, IHeadRowState } from './models/index.js';
import { HEAD_ROW_CATEGORY_KEY, HEAD_ROW_COMPONENT_KEY, HEAD_ROW_PARENT_COMPONENT_KEY } from './HeadRow.meta.js';

export class HeadRow extends TableComponentBase<
	IHeadRowProps & React.TableHTMLAttributes<HTMLTableRowElement>,
	IHeadRowState,
	IHeadRowConfiguration
> {
	categoryKey = HEAD_ROW_CATEGORY_KEY;
	componentKey = HEAD_ROW_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return HEAD_ROW_PARENT_COMPONENT_KEY;
	}
	get tableEventsKey(): keyof ITableEvents {
		return 'headerRow';
	}
	constructor(props: IHeadRowProps) {
		super(props);
	}

	render() {
		const {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			children,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			configuration,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			componentStyle,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			componentStyleProps,

			table,
			rowIndex,
			headerRow,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			columns,
			className: rawClassName = '',
			...otherProps
		} = this.props;
		const events = this.getEvents(this.eventsForElement, undefined, rowIndex);
		const className = `${rawClassName} -ksys-head-row-index-${rowIndex}`;
		return (
			<tr className={className} {...events} {...otherProps}>
				{headerRow &&
					headerRow.map((headerMap, headerMapIndex) => {
						const { group, column, colSpan, columnIndex, rowSpan } = headerMap;
						if (group) {
							const headCellKey = this.getHeadCellKey(rowIndex, headerMapIndex, group);
							const headCellStyleProps = this.getHeadCellStyleProps(rowIndex, group, headerMapIndex);
							return (
								<HeadCell
									scope="colgroup"
									key={headCellKey}
									{...headCellStyleProps}
									table={table}
									colSpan={colSpan}
									rowSpan={rowSpan}
									rowIndex={rowIndex}
									column={group}
									columnIndex={headerMapIndex}
								/>
							);
						}
						if (column && typeof columnIndex === 'number') {
							const headCellKey = this.getHeadCellKey(rowIndex, columnIndex, column);
							const headCellStyleProps = this.getHeadCellStyleProps(rowIndex, column, columnIndex);
							return (
								<HeadCell
									scope="col"
									key={headCellKey}
									{...headCellStyleProps}
									table={table}
									rowIndex={rowIndex}
									column={column}
									colSpan={colSpan}
									rowSpan={rowSpan}
									columnIndex={columnIndex}
								/>
							);
						}
					})}
				{!headerRow &&
					columns &&
					columns.map((column, columnIndex) => {
						const headCellKey = this.getHeadCellKey(rowIndex, columnIndex, column);
						const headCellStyleProps = this.getHeadCellStyleProps(rowIndex, column, columnIndex);
						return (
							<HeadCell
								scope="col"
								key={headCellKey}
								{...headCellStyleProps}
								table={table}
								rowIndex={rowIndex}
								column={column}
								columnIndex={columnIndex}
							/>
						);
					})}
			</tr>
		);
	}
}

export default InjectedStyledComponent(observer(HeadRow), HEAD_ROW_CATEGORY_KEY, HEAD_ROW_PARENT_COMPONENT_KEY, [
	HEAD_ROW_COMPONENT_KEY,
]);
